module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-15.4863cf15.png";